import dayjs from "dayjs";

const getIntervalDates = (startDate, endDate) => {
  if (!startDate || !endDate) return [];

  const dates = [];

  let current = dayjs(startDate);
  const end = dayjs(endDate);

  while (current.isBefore(end)) {
    dates.push(current);
    current = current.add(1, "day");
  }

  return dates?.length ? dates : [];
};

export default getIntervalDates;
